declare global {
  interface Window {
    fbq?: (...args: any[]) => void;
    gtag?: (...args: any[]) => void;
    dataLayer?: any[];
  }
}

export function trackEvent(eventName: string, params?: Record<string, any>) {
  if (window.fbq) {
    window.fbq("track", eventName, params);
  }
  if (window.gtag) {
    window.gtag("event", eventName, params);
  }
}

export function trackWhatsAppClick(source: string) {
  trackEvent("Contact", { method: "whatsapp", source });
}

export function trackPhoneClick(source: string) {
  trackEvent("Contact", { method: "phone", source });
}

export function trackFormSubmit(source: string, serviceType: string) {
  trackEvent("Lead", { source, service_type: serviceType });
  if (window.fbq) {
    window.fbq("track", "Lead", { content_name: source, content_category: serviceType });
  }
}

export const WHATSAPP_NUMBER = "34644394501";
export const PHONE_NUMBER = "+34 644 39 45 01";
export const PHONE_HREF = "tel:+34644394501";
export const EMAIL = "info@tdmalogistica.com";

export function getWhatsAppUrl(message?: string) {
  const msg = message || "Hola, me gustaría solicitar un presupuesto de transporte.";
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;
}
